import BlockOne from "./blockOne/blockOne";
import BlockTwo from "./blockTwo/blockTwo";
import BlockThree from "./blockThree/blockThree";
import BlockFour from "./blockFour/blockFour";
import BlockFive from "./blockFive/blockFive";
import BlockSix from "./blockSix/blockSix";
import BlockSeven from "./blockSeven/blockSeven";
import BlockEight from "./blockEight/blockEight";

export { BlockOne, BlockTwo, BlockThree, BlockFour, BlockFive, BlockSix, BlockSeven, BlockEight }

